import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import SettingsModal from '../Components/Modals/SettingsModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'Settings'>;

const SettingsScreen: React.FC<Props> = ({ navigation }) => {
	return <SettingsModal onClose={() => navigation.goBack()} renderInline />;
};

export default SettingsScreen;
